import { actionCreator } from '../common';
import { LoaderActionTypes } from '../types';

export const loaderActionCreator = {
  changeLoaderStatus: actionCreator<boolean>(LoaderActionTypes.CHANGE_LOADER_STATUS),
};
